export class MainMenuPageEntity
{
    TabName: string;
    Value: string;

    constructor(
        TabName: string,
        Value: string
    )
    {
        this.Value = Value;
        this.TabName = TabName;
    }
}